import nodeCache from "node-cache";

import { UhfData } from "../models";

const uhfCache = new nodeCache({
  stdTTL: 60 * 60 * 24, // 24 hours
});
const uhfDataKeyFormat = "uhfData-{locale}";

export const storeUhfInCache = (uhfData: UhfData, locale: string) => {
  const uhfDataKey = uhfDataKeyFormat.replace("{locale}", locale);
  const existingUhfData = uhfCache.get(uhfDataKey);
  if (!existingUhfData) {
    uhfCache.set(uhfDataKey, uhfData);
  }
};

export const getUhfFromCache = (locale: string): UhfData | undefined =>
  uhfCache.get(uhfDataKeyFormat.replace("{locale}", locale));
